import { SaasName } from '../../../../app/constants/application';
import { CarePlusStatregy } from '../../../../app/services/strategy/careplus-strategy';
import { type APIStrategy } from '../../../services/strategy/api-strategy';
import { EinsteinStrategy } from '../../../services/strategy/einstein-strategy';
import { FleuryStrategy } from '../../../services/strategy/fleury-strategy';

export class CreateApiStrategy {
  constructor(
    private readonly token: string | null,
    private readonly saasName: string
  ) {}

  execute(): APIStrategy {
    switch (this.saasName) {
      case SaasName.EINSTEIN:
        return new EinsteinStrategy(this.token);
      case SaasName.FLEURY:
        return new FleuryStrategy(this.token);
      case SaasName.CAREPLUS:
        return new CarePlusStatregy(this.token);
      default:
        return new EinsteinStrategy(this.token);
    }
  }
}
